

import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { CgMenu, CgCloseR } from 'react-icons/cg'; // Added CgCloseR import
import logo2 from "../Assets/AzDania.png";

// Styled Nav element
const Nav = styled.nav`
  background-color:#171764;
  padding: 1rem;
  position: relative;
  
`;

// Menu icon container (for hamburger icon in mobile view)
const MenuIcon = styled(CgMenu)`
  display: none;
  font-size: 30px;
  color: white;

  @media (max-width: 1000px) {
    display: block;
  }
`;

// Unordered list to style the navbar items
const NavbarUl = styled.ul`
  display: flex;
  align-items: center;
  gap: 2rem;
  margin: 0;
  padding: 0;
  list-style: none;
  @media (max-width: 1000px) {
    display: none;  // Hide the navbar items when the screen size is less than 1000px
  }
`;

// Individual list items in the navbar
const NavbarLi = styled.li`
  display: inline-block;
  text-decoration: none;
  font-size: 13px;
  font-weight: bold;
  color: black;
  text-transform: uppercase;
  transition: color 0.3s linear;
  position: relative;

  &:hover,
  &:active,
  &:focus {
    color:black;
  }

  

  
`;

// Styled NavLink for each navbar item
const StyledNavLink = styled(NavLink)`
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;
  color: white;
  text-transform: uppercase;
  padding: 10px 20px;
  transition: color 0.3s ease, background-color 0.3s ease;

  &:hover,
  &.active {
    color: #333;
    background-color: #fff;
    border-radius: 5px;
  }
`;

// Backdrop styled component for overlay
const Backdrop = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 500; /* Slightly less than the SideNav's z-index */
`;

// SideNav styled component for the sidebar
const SideNav = styled.div`
  height: 100%;
  width: ${({ isOpen }) => (isOpen ? '70%' : '0')};
  position: fixed;
  z-index: 2147483647 !important;
  top: 0;
  left: 0;
  background-color: #ffffff;
  overflow-x: hidden;
  transition: 0.3s;
  display: none; /* Hide initially */

  @media screen and (max-width: 1000px) {
    display: flex; /* Show for screens smaller than 1000px */
    flex-direction: column;
    padding-top: 130px;
    width: ${({ isOpen }) => (isOpen ? '80%' : '0')}; /* 80% width for screens smaller than 1000px */
  }

  @media screen and (max-width: 600px) {
  width: ${({ isOpen }) => (isOpen ? '100%' : '0')}; /* 100% width for screens smaller than 600px */
  align-items: center;
  justify-content: center;
  font-size: 24px; /* Increased font size for better readability */
  line-height: 1.8; /* Added line-height for more spacing between lines */
  letter-spacing: 1.5px;
  background: linear-gradient(to bottom,rgb(163, 60, 60),rgb(159, 158, 160),rgb(120, 160, 112)); /* Professional gradient */
  color: #000000; /* Black text color for contrast */
  /* font-size: 20px; */
  /* background: linear-gradient(to bottom, #ffffff, #1c23b4, #b91010, #570808);  White linear gradient from top to bottom */
}

`;

const Logo1 = styled.img`
  position: absolute;
  top: 15px;
  left: 20px;
  width: 120px;

  @media (max-width: 600px) {
    width: 120px;
    height: 150px;
    top: 1px;
  }
`;

const SideNavCloseIcon = styled(CgCloseR)`
  position: absolute;
  top: 15px;
  right: 20px;
  color: #000000;
  cursor: pointer;
  font-size: 30px;

  @media (max-width: 1000px) {
    top:65px;
    right: 55px;
  }
`;

const NavbarItem = styled.li`
  list-style: none;
`;

const NavbarLink1 = styled(NavLink)`
  display: inline-block;
  text-decoration: none;
  /* margin-left: 20px; */
  /* background-color: red; */
  padding-left:20px;
  line-height: 20px;
  font-size: 13px;
  font-weight: bold;
  color:black;
  text-transform: uppercase;
  transition: color 0.3s linear;
  position: relative;

  &:hover,
  &:active,
  &:focus {
    color:black;
  }

  &::before {
    content: '';
    width: 100%;
    height: 2px;
    background-color: #000000;
    position: absolute;
    left: 0;
    bottom: -5px;
    transform: scaleX(0);
    transform-origin: right;
    transition: transform 0.3s ease-in-out;
  }

  &:hover::before,
  &:active::before,
  &:focus::before {
    transform: scaleX(1);
    transform-origin: left;
  }
`;

const Navbar = () => {
  const [isSideNavOpen, setIsSideNavOpen] = useState(false);

  // Toggle side nav visibility
  const toggleSideNav = () => {
    setIsSideNavOpen(!isSideNavOpen);
  };

  // Handle item click to close the side nav
  const handleItemClick = () => {
    setIsSideNavOpen(false);
  };

  return (
    <Nav>
      {/* MenuIcon triggers the side nav toggle */}
      <MenuIcon className="menuIcon" onClick={toggleSideNav} />

      {/* Backdrop will overlay the screen when the side nav is open */}
      <Backdrop isOpen={isSideNavOpen} onClick={toggleSideNav} />

      {/* Side Navigation */}
      <SideNav isOpen={isSideNavOpen}>
        <Logo1 src={logo2} alt="Logo" />
        <SideNavCloseIcon onClick={toggleSideNav} />
        <NavbarItem><NavbarLink1 to="/" onClick={handleItemClick}>Home</NavbarLink1></NavbarItem>
        <NavbarItem><NavbarLink1 to="/products" onClick={handleItemClick}>Products</NavbarLink1></NavbarItem>
        <NavbarItem><NavbarLink1 to="/aboutus" onClick={handleItemClick}>About Us</NavbarLink1></NavbarItem>
        <NavbarItem><NavbarLink1 to="/contactus" onClick={handleItemClick}>Contact Us</NavbarLink1></NavbarItem>
      </SideNav>

      {/* Navbar items for larger screens */}
      <NavbarUl>
        <NavbarLi>
          <StyledNavLink to="/" activeClassName="active">Home</StyledNavLink>
        </NavbarLi>
        <NavbarLi>
          <StyledNavLink to="/products" activeClassName="active">Products</StyledNavLink>
        </NavbarLi>
        <NavbarLi>
          <StyledNavLink to="/aboutus" activeClassName="active">About Us</StyledNavLink>
        </NavbarLi>
        <NavbarLi>
          <StyledNavLink to="/contactus" activeClassName="active">Contact Us</StyledNavLink>
        </NavbarLi>
      </NavbarUl>
    </Nav>
  );
};

export default Navbar;
